import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';
import { useNavigate } from 'react-router-dom';

export default function ArticleGrid() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleArticleClick = (slug: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      navigate(`/artikel/${slug}`);
    }, 150);
  };

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium text-accent-500 uppercase tracking-widest mb-3">
            SEO Guides
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            OOPBuy Spreadsheet
            <br />
            <span className="italic font-normal text-secondary-500">Ratgeber & Anleitungen</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Expertenwissen rund um das OOPBuy Spreadsheet. Unsere Guides helfen dir, bessere Entscheidungen zu treffen und Geld zu sparen.
          </p>
        </div>

        {/* Articles grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <button
              key={article.slug}
              onClick={() => handleArticleClick(article.slug)}
              className="group bg-background-50 rounded-2xl overflow-hidden hover:shadow-lg transition-all duration-300 cursor-pointer text-left hover:-translate-y-1 w-full"
            >
              <div className="aspect-[16/10] relative overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium backdrop-blur-sm">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2 leading-snug group-hover:text-accent-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-sm font-medium text-accent-600">
                  <span>Weiterlesen</span>
                  <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* View all link */}
        <div className="text-center mt-10">
          <button
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
              setTimeout(() => navigate('/artikel/oopbuy-spreadsheet-guide'), 150);
            }}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-200 text-foreground-900 text-sm font-medium hover:bg-foreground-900 hover:text-background-50 hover:border-foreground-900 transition-all cursor-pointer whitespace-nowrap"
          >
            Alle Guides ansehen
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}